import React, { Component } from 'react';
import PropTypes from "prop-types";

import withStyles from "@material-ui/core/styles/withStyles";
import RefreshIcon from '@material-ui/icons/Refresh';
import { Grid } from '@material-ui/core';

// core components
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Table from "components/Table/Table.jsx";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";

import ArticleBody from './ArticleBody';
import ArticleFooter from './ArticleFooter';
// import ArticleBack from './ArticleBack';
import { toTitleCase } from './utilities';

// styles
import imagesStyles from "assets/jss/material-kit-pro-react/imagesStyles.jsx";
import cardStyles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.jsx";

// actions
import axios from 'axios';
import { SEARCH_BASE_URL } from '../../../config';

const buttonCategories = [
    "social sector", 
    "advisory",
    "grant", 
    "rfp", 
    "scholarship",
    "staff change"
];

const styles = theme => ({
    ...imagesStyles,
    ...cardStyles,
    mainNewsCardContainer: {},
    topNewsCardContainer: {
        minWidth: 'calc(100% - 10px)',
        height: '300px',
        transitionDuration: '0.3s',
    },
    newsCardContainer: {height: '100%'},
    articleCard: {
        display: 'flex',
        marginTop: 0,
        marginBottom: 0,
        transitionDuration: '0.3s',
        minHeight: '11.5vw',
        height: '100%',
        textAlign: 'left',
        borderRadius: 0
    },
    articleCardDetails: {
        flex: 1,
        paddingLeft: `${theme.spacing.unit * 3}px`,
        paddingRight: `${theme.spacing.unit * 3}px`,

    },
    closeButton: {backgroundColor: "#000000 !important"},
    feedbackButton: {
        maxWidth: '30%',
        float: 'right',
        zIndex: '10000',
        borderRadius: 0,
        backgroundColor: "#000000 !important",
        color: "#FFF !important"
    },
    frontButtonsCard: {padding: 0},
    frontShow: {},
    frontHide: {/*display: "none !important"*/},
    articleBack: {'overflow-y': 'scroll'},
    Yes: {
        backgroundColor: "#febe10 !important",
        color: "#000000 !important"
    },
    No: {
        backgroundColor: "#febe10 !important",
        color: "#000000 !important"
    },
    Maybe: {
        backgroundColor: "#febe10 !important",
        color: "#000000 !important"
    }
})

class Article extends Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.categories = this.categories.bind(this);
        this.cardClickOpen = this.cardClickOpen.bind(this);
        this.simpleButtons = this.simpleButtons.bind(this);
        this.handleYesNoClick = this.handleYesNoClick.bind(this);
        this.handleFrontYesNoClick = this.handleFrontYesNoClick.bind(this);
    }

    simpleButtons(category, label=null, feedbackData=null, isFront=false) {
        category = category.replace(/\s/g, '');
        if (label !== null) {
            category += `-${label}`;
        }
        const { classes, record } = this.props;
        const articleKey = `article-${record.data_id}`,
            feedback = feedbackData ? feedbackData : this.state[articleKey];

        return ["No", "Maybe", "Yes"].map((property, index) => {
            const baseClass = `${record.data_id}-${category}-${property}`;
            const clickFunc = isFront ? this.handleFrontYesNoClick : this.handleYesNoClick;

            let clickedClass = "";
            if (feedback && category in feedback) {
                if (property === feedback[category])
                    clickedClass = classes[property];
            }

            return (
                clickedClass === "" ?
                    <Button size="sm" color="primary"
                        className={`${classes.feedbackButton} ${baseClass}`} value={baseClass} onClick={clickFunc}>
                        {property}
                    </Button> : 
                    <Button size="sm" 
                        className={`${classes.feedbackButton} ${baseClass} ${clickedClass}`}
                        value={baseClass} onClick={clickFunc}>
                        {property}
                    </Button>
            )
        })
    }

    categories() {
        return (
            [
                "social sector", 
                "grant", 
                "rfp", 
                "scholarship",
                "staff change"
            ].filter(category => category !== null)
        )
    }

    handleYesNoClick(event) {
        const { record } = this.props;
        const articleKey = `article-${record.data_id}`;
        const prevState = this.state[articleKey];
        let voteDetails = event.target.value;

        if (voteDetails === undefined) {
            voteDetails = event.target.parentElement.value;
        }

        if (voteDetails && voteDetails !== "") {
            const type = voteDetails.split("-")[1],
                vote = voteDetails.split("-")[2],
                hasChanged = `${type}HasChanged`;

            const stateObject = {
                [articleKey]: {
                    ...prevState,
                    [type]: vote,
                    [hasChanged]: !this.state[articleKey][hasChanged],
                    yesNoClick: false
                }
            };
            this.setState(stateObject);
        }
    }

    handleFrontYesNoClick(event) {
        const { record } = this.props;
        let voteDetails = event.target.value;
        if (voteDetails === undefined)
            voteDetails = event.target.parentElement.value;

        const buttons = document.getElementById(`${record.data_id}`).getElementsByTagName('button');

        for (let i=0; i<buttons.length; i++) {
            let button = buttons[i];
            button.style = "background-color: #000000 !important; color: #FFF !important;";
        }

        if (voteDetails && voteDetails !== "") {
            const split = voteDetails.split('-'),
                size = split.length;
            const type = split.slice(1, size - 1).join('-'),
                vote = split[size - 1];

            const targetButtons = document.getElementsByClassName(voteDetails);
            for (let i=0; i<targetButtons.length; i++) {
                let button = targetButtons[i];
                button.style = "background-color: #febe10 !important; color: #000000 !important;";
            }

            let voteInt = 0;
            if (vote === "Yes")
                voteInt = 1;
            else if (vote === "No")
                voteInt = 0;
            else if (vote === "Maybe")
                voteInt = 2;
            
            const payload = {
                dataId: record.data_id,
                route: "send_feedback",
                [type]: voteInt
            }
            axios.post(SEARCH_BASE_URL, payload, {withCredentials: true});
        }
    }

    renderBack() {
        const { record, classes } = this.props;
        const articleKey = `article-${record.data_id}`;
        
        if (!this.state[articleKey] || (this.state[articleKey] && !this.state[articleKey].showUserFeedback))
            return <CustomLinearProgress color="primary" />

        let initialState = {[`${articleKey}`]: {}};

        // const categories = this.categories(), 
        //     tableData = categories.map(category => {
        //         return [
        //             `Is ${toTitleCase(category).replace(/\s/g, '')}?`,
        //             this.simpleButtons(category)
        //         ]
        //     });
        const tableData = buttonCategories.map(category => {
            return [
                `Is ${toTitleCase(category).replace(/\s/g, '')}?`,
                this.simpleButtons(category)
            ]
        })

        initialState[articleKey] = {backState: "open"};
        // categories.map(category => {initialState[articleKey][`${category.replace(/\s/g, '')}HasChanged`] = false;});
        buttonCategories.map(category => {initialState[articleKey][`${category.replace(/\s/g, '')}HasChanged`] = false;});

        if (articleKey in this.state && this.state[articleKey].backState === "opening") 
            this.setState(initialState);

        return (
            <CardBody className={`${classes.cardBodyRotate} ${classes.articleBack}`}>
                <Table tableHead={["Category", "Actions"]} tableData={tableData} />
                <CardFooter className={classes.cardBodyRotate}>
                    <div className={`${classes.stats} ${classes.mlAuto}`}>
                        {/* <Button round justIcon color="primary" className={classes.closeButton} onClick={() => this.cardClickClose(categories)}> */}
                        <Button round justIcon color="primary" className={classes.closeButton} onClick={() => this.cardClickClose(buttonCategories)}>
                            <RefreshIcon />
                        </Button>
                    </div>
                </CardFooter>
            </CardBody>
        )
    }

    renderFrontButtons(inputCategories, message=null) {
        const { record, classes } = this.props;
        const { feedback } = record;
        const articleKey = `article-${record.data_id}`;

        let initialState = {[`${articleKey}`]: {}};
        // const feedback = record.nativeAmericanFeedback ? {nativeamerican: record.nativeAmericanFeedback} : null;
        const tableData = inputCategories.map(category => {
            let topic = category;
            let label = null;
            if (typeof(category) == "object" && category.length === 2) {
                topic = category[1];
                label = category[0];
            }
            initialState[articleKey][`${topic.replace(/\s/g, '')}HasChanged`] = false;
            return [
                message ? 
                    `${message}: ${toTitleCase(topic).replace(/\s/g, ' ')}` : 
                    `Is for ${toTitleCase(topic).replace(/\s/g, ' ')} philanthropy project?`,
                this.simpleButtons(topic, label, feedback, true)
            ]
        });

        initialState[articleKey] = {firstRender: false, loadingNap: false};
        // inputCategories.map(category => {
        //     initialState[articleKey][`${topic.replace(/\s/g, '')}HasChanged`] = false;
        // });

        return (
            <CardBody id={record.data_id} className={classes.frontButtonsCard}>
                <Table tableData={tableData} />
            </CardBody>
        )
    }

    cardClickClose(categories) {
        const { classes, record } = this.props;
        const articleKey = `article-${record.data_id}`;
        const state = this.state;
        // const shouldSend = this.categories().some(category => {return state[articleKey][`${category.replace(/\s/g, '')}HasChanged`];});
        const shouldSend = buttonCategories.some(category => {return state[articleKey][`${category.replace(/\s/g, '')}HasChanged`];});

        if (shouldSend) {
            let payload = {};

            // this.categories().map((category, index) => {
            buttonCategories.map((category, index) => {
                const catKey = category.replace(/\s/g, '');
                
                let catState = null;
                if (state[articleKey][catKey] === "No")
                    catState = 0
                else if (state[articleKey][catKey] === "Yes")
                    catState = 1
                else if (state[articleKey][catKey] === "Maybe")
                    catState = 2

                if (catState !== null)
                    payload[catKey] = catState;
            });
            payload.dataId = record.data_id;
            payload.route = "send_feedback";
            axios.post(SEARCH_BASE_URL, payload, {withCredentials: true});
        }

        let initialState = {[`${articleKey}`]: {backState: "closed"}};
        categories.map(category => {initialState[`${articleKey}`][`${category.replace(/\s/g, '')}HasChanged`] = false;});

        //todo: put a check to see if all categories are selected, then mark as "complete"
        const current = {...initialState[`${articleKey}`], ...this.state[`${articleKey}`]};
        // const complete = this.categories().every((category, index) => {return category in current});
        const complete = buttonCategories.every((category, index) => {return category in current});
        if (complete) {
            initialState[articleKey].complete = true;
            const payload = {
                route: "mark_complete",
                dataId: record.data_id
            };
            axios.post(SEARCH_BASE_URL, payload, {withCredentials: true});
        }

        initialState[`activeRotate${record.data_id}`] = "";
        initialState[`hideFront${record.data_id}`] = classes.frontShow;
        this.setState(initialState);
    }

    cardClickOpen() {
        const { classes, record } = this.props;
        const articleKey = `article-${record.data_id}`;
        const prevState = this.state[articleKey];

        let initialState = {
            [`activeRotate${record.data_id}`]: classes.activateRotate,
            [`hideFront${record.data_id}`]: classes.frontHide,
            [articleKey]: {
                ...prevState,
                backState: "opening",
                yesNoClick: false
            }
        };
        // this.categories().map(category => {initialState[articleKey][`${category.replace(/\s/g, '')}HasChanged`] = false;});
        buttonCategories.map(category => {initialState[articleKey][`${category.replace(/\s/g, '')}HasChanged`] = false;});
        this.setState(initialState);

        axios.post(SEARCH_BASE_URL, {dataId: record.data_id, route: "get_feedback"}, {withCredentials: true})
            .then(response => {
                if (response.data) {
                    this.setState({
                        [`${articleKey}`]: {
                            ...prevState, 
                            ...response.data.topics,
                            showUserFeedback: true,
                            backState: "open"
                        }
                    });
                }
            })
    }

    render() {
        const { record, isGrant, classes, utcStart} = this.props;
        let className = isGrant ? classes.topNewsCardContainer : classes.mainNewsCardContainer;

        if (record.isNAP && isGrant) {
            className = `${className} nap-grant`
        }

        return (
            <Grid item key={`${isGrant}-${record.data_id}`} 
                xs={12} md={isGrant ? 6 : 4} 
                className={className}>
                <div className={`${classes.rotatingCardContainer} ${classes.manualRotate} ${classes.newsCardContainer} ${this.state['activeRotate' + record.data_id]}`}>
                    <Card className={`${classes.articleCard} ${classes.cardRotate}`}>
                        <CardBody className={`${classes.articleCardDetails} ${classes.cardBodyRotate} ${this.state['hideFront' + record.data_id]}`} plain>
                            
                            <ArticleBody record={record} recordState={this.state[`article-${record.data_id}`]} utcStart={utcStart} />

                            {
                                record.isNAP ? 
                                    <div className="front-button-container">
                                        {this.renderFrontButtons(["native american"])}
                                    </div> 
                                    : null
                            }
                            {
                                this.props.subjects ? 
                                    <div className="front-button-container">
                                        {this.renderFrontButtons(this.props.subjects, 'Relevant subject code?')}
                                    </div> 
                                    : null
                            }
                        </CardBody>

                        <ArticleFooter record={record} clickOpenFunc={this.cardClickOpen} />

                        <div className={classes.back}>
                            {this.renderBack()}
                        </div>
                    </Card>
                </div>
            </Grid>
        )
    }
}

Article.propTypes = {
    classes: PropTypes.object,
    optionalBannerClasses: PropTypes.object,
    record: PropTypes.object,
    isGrant: PropTypes.bool,
    subjects: PropTypes.array,
    utcStart: PropTypes.instanceOf(Date)
}

export default withStyles(styles)(Article);


// WEBPACK FOOTER //
// ./src/components/Article/common/Article.jsx